import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { KindsModalComponent } from '../../layout/kindsmodal/kindsmodal.component';

@Component({
  selector: 'app-changelistkind',
  templateUrl: './changelistkind.component.html',
  styleUrls: ['./changelistkind.component.css']
})
export class ChangeListComponent {

  @ViewChild(KindsModalComponent) kindsModal : KindsModalComponent;

  constructor(private _data:DataService,
              private _blogic:BusinesLogicService) {}

  openKindModal() {
      this.kindsModal.openKindModal("atypesListModal");
  }
}
